import React from 'react';
import { Link } from 'react-router-dom';
import { useCollections } from '../../lib/api/collections';
import { newsImages } from '../../data/images';


const Sidebar = ({ activeCategory }) => {
  const { news } = useCollections('news');
  if (!news) return null;
  const categories = [...new Set(news.map((n) => n.category).filter(Boolean))];
  // The most used tags across the posts.
  const tagCounts = {};
  news.forEach((n) => ((n.article && n.article.tags) || []).forEach((t) => { tagCounts[t] = (tagCounts[t] || 0) + 1; }));
  const tags = Object.keys(tagCounts).sort((a, b) => tagCounts[b] - tagCounts[a]).slice(0, 8);
  const posts = news.slice(0, 5);

  return (
    <div className="it-sv-details-sidebar">
      <div className="it-sv-details-sidebar-search mb-55">
        <input type="text" placeholder="search" />
        <button type="submit">
          <i className="fal fa-search"></i>
        </button>
      </div>
      <div className="it-sv-details-sidebar-widget mb-55">
        <h4 className="it-sv-details-sidebar-title mb-30">News Categories</h4>
        {categories.map((category) => (
          <Link key={category} to={`/news?category=${encodeURIComponent(category)}`}>
            <div
              className={
                category === activeCategory
                  ? 'it-sv-details-sidebar-category active mb-10'
                  : 'it-sv-details-sidebar-category mb-10'
              }
            >
              {category}
              <span>
                <i className="fa-light fa-angle-right"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
      <div className="sidebar__widget mb-55">
        <div className="sidebar__widge-title-box">
          <h3 className="sidebar__widget-title pb-10">Recent Posts</h3>
        </div>
        <div className="sidebar__widget-content">
          <div className="sidebar__post">
            {posts.map((post) => (
              <div
                key={post.id}
                className="rc__post mb-30 d-flex align-items-start"
              >
                <div className="rc__post-thumb mr-20">
                  <Link to={`/news/${post.id}`}>
                    <img src={newsImages(post).thumb} alt="" />
                  </Link>
                </div>
                <div className="rc__post-content">
                  <div className="rc__meta">
                    <span>
                      <i className="fa-solid fa-calendar-days"></i>
                      {post.date}
                    </span>
                  </div>
                  <h3 className="rc__post-title">
                    <Link to={`/news/${post.id}`}>{post.titleTiny}</Link>
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="it-sv-details-sidebar-widget">
        <h4 className="it-sv-details-sidebar-title mb-30">Popular Tags:</h4>
        <div className="sidebar__widget-content">
          <div className="tagcloud">
            {tags.map((tag) => (
              <a key={tag} href="#">
                {tag}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
